// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a30b1a8d","453":"f59881fb","455":"c6e11a54","977":"657d5d76"}[chunkId] + ".chunk.js";
};